module.exports = "<div *ngIf='hotel'>\n    <img class='brand-logo-container' src='/resources/global/stay-mgmt/v12.0.0/assets/svg/brand-logos/round/{{(hotel.chainCode) | lowercase}}.svg' data-slnm-ihg='hotelBrandLogoSID'/>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/brand-logo/brand-logo.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/brand-logo/brand-logo.component.html
// module chunks = 0